import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CardNumberElement, CardCVCElement, CardExpiryElement } from 'react-stripe-elements';

import StripeFieldWrapper from './StripeFieldWrapper/StripeFieldWrapper';

import TextField from '../../../components/_atomic/TextField/TextField';
import { cardNameValidation } from '../../../utils/helpers';
import { TEXT_FIELD_STATUS } from '../../../utils/constants';

const cardNumberFieldName = 'card-number';
const cardExpirationFieldName = 'card-expiration';
const cardCVCFieldName = 'card-cvc';

const stripeFieldInitialState = {
  isFocused: false,
  isEmpty: true,
  isError: '',
  isComplete: false,
};

const commonStyle = {
  base: {
    fontSize: '12px',
    color: '#000000',
    '::placeholder': {
      fontSize: '10px',
      color: 'a1a1a1',
    },
  },

  invalid: {
    color: '#e6506d',
  },
};
class CardSection extends Component {
  static propTypes = {
    nameTextField: PropTypes
      .shape({})
      .isRequired,
    nameTextFieldName: PropTypes.string.isRequired,
    registerField: PropTypes.func.isRequired,
    changeHandler: PropTypes.func.isRequired,
    focusHandler: PropTypes.func.isRequired,
    stripeCardStatusHandler: PropTypes.func.isRequired,
  }
  state = {
    fields: {
      [cardNumberFieldName]: {
        ...stripeFieldInitialState,
      },
      [cardExpirationFieldName]: {
        ...stripeFieldInitialState,
      },
      [cardCVCFieldName]: {
        ...stripeFieldInitialState,
      },
    },
  }
  getStripeCardStatus = () => {
    const fields = {
      ...this.state.fields,
    };
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    let stripeCardStatus = TEXT_FIELD_STATUS.INITIAL;
    fieldsNames.forEach((fieldName) => {
      if (fields[fieldName].isError) {
        invalidFields += 1;
      }
      if (fields[fieldName].isComplete) {
        validFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      stripeCardStatus = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      stripeCardStatus = TEXT_FIELD_STATUS.INVALID;
    }
    return stripeCardStatus;
  }

  focusHandler = (name) => {
    const fields = {
      ...this.state.fields,
    };
    fields[name].isFocused = true;
    this.setState(() => ({ fields }));
  }

  blurHandler = (name) => {
    const fields = {
      ...this.state.fields,
    };
    fields[name].isFocused = false;
    this.setState(() => ({ fields }));
  }


  changeHandler = (name, e) => {
    const fields = {
      ...this.state.fields,
    };
    fields[name].isEmpty = e.empty;
    fields[name].isError = e.error && e.error.message;
    fields[name].isComplete = e.complete;


    this.setState(() => ({ fields }), () => {
      this.props.stripeCardStatusHandler(this.getStripeCardStatus());
    });
  }
  render() {
    const { fields } = this.state;
    const {
      registerField,
      changeHandler,
      focusHandler,
      nameTextField: {
        value,
        isFocused,
        status,
        errorText,
      },
      nameTextFieldName,
    } = this.props;
    const cardNumberField = fields[cardNumberFieldName];
    const cardExpirationField = fields[cardExpirationFieldName];
    const cardCVCField = fields[cardCVCFieldName];

    return (
      <React.Fragment>
        <StripeFieldWrapper
          label="Card Number"
          isComplete={cardNumberField.isComplete}
          isFocused={cardNumberField.isFocused}
          isEmpty={cardNumberField.isEmpty}
          isError={cardNumberField.isError}
          className="credit-card"
        >
          <CardNumberElement
            onFocus={(e) => {
            this.focusHandler(cardNumberFieldName, e);
          }}
            onBlur={(e) => {
            this.blurHandler(cardNumberFieldName, e);
          }}
            onChange={(e) => {
            this.changeHandler(cardNumberFieldName, e);
          }}
            style={commonStyle}
          />
        </StripeFieldWrapper>
        <TextField
          registerField={registerField}
          value={value}
          isFocused={isFocused}
          changeHandler={changeHandler}
          focusHandler={focusHandler}
          name={nameTextFieldName}
          status={status}
          errorText={errorText}
          specifiedValidator={cardNameValidation}
          placeholder="Name on Card"
          label="Name on Card"
          hint="To speed up verification we recommend filling this feild"
        />
        <div className="card-bottom-wrapper">
          <StripeFieldWrapper
            label="Expiration date"
            className="expiration-card"
            isComplete={cardExpirationField.isComplete}
            isFocused={cardExpirationField.isFocused}
            isEmpty={cardExpirationField.isEmpty}
            isError={cardExpirationField.isError}
          >
            <CardExpiryElement
              onFocus={(e) => {
              this.focusHandler(cardExpirationFieldName, e);
            }}
              onBlur={(e) => {
              this.blurHandler(cardExpirationFieldName, e);
            }}
              onChange={(e) => {
              this.changeHandler(cardExpirationFieldName, e);
            }}
              style={commonStyle}
            />
          </StripeFieldWrapper>
          <StripeFieldWrapper
            label="CVC"
            className="cvc-card"
            isComplete={cardCVCField.isComplete}
            isFocused={cardCVCField.isFocused}
            isEmpty={cardCVCField.isEmpty}
            isError={cardCVCField.isError}
          >
            <CardCVCElement
              onFocus={(e) => {
              this.focusHandler(cardCVCFieldName, e);
            }}
              onBlur={(e) => {
              this.blurHandler(cardCVCFieldName, e);
            }}
              onChange={(e) => {
              this.changeHandler(cardCVCFieldName, e);
            }}
              style={commonStyle}
            />
          </StripeFieldWrapper>
        </div>

      </React.Fragment>

    );
  }
}
export default CardSection;



// WEBPACK FOOTER //
// ./src/components/StripeCard/components/CardSection.js